import { format } from 'date-fns-tz';

export const DATE_TIME_TIMEZONE_FORMAT = 'yyyy-MM-dd, hh:mm a zzz';

const DATE_FORMAT = 'yyyy-MM-dd';

export const formatDate = (date: Date, fmt?: string): string => {
  return format(date, fmt || DATE_FORMAT);
};

// When the time zone offset is absent, date-only forms are interpreted as a UTC time and date-time forms are interpreted as local time.
export const getDateFromDateOnlyString = (date: string): Date => {
  return new Date(`${date}T00:00:00`);
};
